import request from '@/router/axios'
import env from '@/config/env'
import { pickBy } from 'lodash-es'
import qs from 'qs'
import globalVariable from '@/config/globalVariable'

const { TIME } = globalVariable

/**
 * 查询城际公司名称
 */
export const getAllLowMerchant = () => {
  return request({
    url: env.ferryUrl + '/merchantPriceAdmin/getAllLowMerchant',
    method: 'GET',
    timeout: TIME
  })
}

/**
 * 查询城际车牌号
 * @param
 */
export const getCar = () => {
  return request({
    url: env.ferryUrl + '/c-order/queryMerchantDriverAndCarInfo',
    method: 'POST',
    timeout: TIME
  })
}

/**
 * 获取线路名称
 * @param params
 */
export const queryAllLowLine = () => {
  return request({
    url: env.ferryUrl + '/merchantPriceAdmin/queryAllLowLine',
    method: 'GET',
    timeout: TIME
  })
}

/**
 * 获取票款结算规则分页
 * @param params
 */
export const getPage = (params) => {
  return request({
    url: env.ferryUrl + '/capital/flow/reconciliation/page',
    method: 'GET',
    timeout: TIME,
    params: params
  })
}

/**
 * 票款同步清分数据
 * @param params
 */
export const clarifyTicketSync = (endDepartureDate, merchantId, startDepartureDate) => {
  return request({
    url:
      env.ferryUrl +
      `/clarify/ticket/sync?endDepartureDate=${endDepartureDate}&&merchantId=${merchantId}&&startDepartureDate=${startDepartureDate}`,
    method: 'POST',
    timeout: TIME
  })
}

/**
 * 资金流水记录导出
 * @param params
 */
export const exportDetails = (queryParam) => {
  let url = env.importExcelUrl + env.ferryUrl + `/capital/flow/reconciliation/export`
  let parma = pickBy({ ...queryParam })
  url = url + '?' + qs.stringify(parma)
  return (window.location.href = url)
}
